import {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react";

import ReactFlow, {
  addEdge,
  Background,
  Controls,
  MiniMap,
  useViewport,
  updateEdge,
  useEdgesState,
  useNodesState,
} from "reactflow";
import "reactflow/dist/style.css";
import { Url } from '../store/global';

import {
  Flex,
  Menu,
  Switch,
  MenuButton,
  MenuList,
  Avatar,
  MenuItem,
  Button,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Select,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Tag,
  useDisclosure,
  Spinner,
  Icon,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Box,
  Tooltip,
  Checkbox,
  InputLeftElement,
  InputGroup,
  useMediaQuery,
  FormControl,
  FormLabel,
  Textarea,
} from "@chakra-ui/react";

import AuthContext from "../store/auth";
import Sidebar from "../components/Sidebar";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { useToast } from "@chakra-ui/react";
import { StarIcon } from '@chakra-ui/icons'

import {
  BsFillFolderFill,
  BsPencilFill,
  BsSearch,
  BsHouse,
  BsTrash,
  BsStar,
  BsFillStarFill
} from "react-icons/bs";
import {
  ChevronDownIcon,
  CloseIcon,
  HamburgerIcon,
  SearchIcon,
} from "@chakra-ui/icons";
import { useHotkeys } from "react-hotkeys-hook";

import SearchInArray from "../components/SearchInArray";
import Breadcrumbs from "../components/BreadCrumbs";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { BiTrash } from "react-icons/bi";
import CustomNode from "../components/CustomNode";

const initialNodes = [];

const initialEdges = [];

const nodeTypes = {
  customNode: CustomNode,
};

function ViewportLogger() {
  const { x, y, zoom } = useViewport();
  const prevViewport = useRef({ x, y, zoom });
  let { projectSlug } = useParams();


  useEffect(() => {
    if (x !== prevViewport.current.x || y !== prevViewport.current.y || zoom !== prevViewport.current.zoom) {
      console.log(`x: ${x}, y: ${y}, zoom: ${zoom}`);
      sessionStorage.setItem(`viewport-${projectSlug}`, JSON.stringify({ x, y, zoom }));
      prevViewport.current = { x, y, zoom };
    }
  }, [x, y, zoom]);

  return null;
}



const Project = () => {
  const toast = useToast();

  const authCtx = useContext(AuthContext);
  // console.log(authCtx);
  let { projectSlug } = useParams();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [loading, setIsloading] = useState(false);
  const [captureElementClick] = useState(true);
  const withCollabs = useRef();
  const withCollabs2 = useRef();

  const [showFilePreview, setShowFilePreview] = useState(
    window.localStorage.getItem("filePreview")
      ? JSON.parse(window.localStorage.getItem("filePreview"))
      : true
  );
  const [collapsedPages, setCollapsedPages] = useState({});

  const [shouldFetch, setShouldFetch] = useState(false);
  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState(initialEdges);
  // connect edges
  const onConnect = useCallback((params) => {
    setEdges((eds) => addEdge(params, eds));
    linkPage(params.target, params.source);
  }, []);

  // delete edges
  const edgeUpdateSuccessful = useRef(true);
  const onEdgeUpdateStart = useCallback(() => {
    edgeUpdateSuccessful.current = false;
  }, []);

  const onEdgeUpdate = useCallback((oldEdge, newConnection) => {
    edgeUpdateSuccessful.current = true;
  
  }, []);

  const onEdgeUpdateEnd = useCallback((_, edge) => {
    if (!edgeUpdateSuccessful.current) {
      setEdges((eds) => eds.filter((e) => e.id !== edge.id));
      deleteLink("this_page_depends_on", edge.source, edge.target);
    }

    edgeUpdateSuccessful.current = true;
  }, []);
  const [projectInfo, setProjectInfo] = useState();
  const [colorFont, setColorFont] = useState();
  const [fav, setFav] = useState();
  const [isCollab, setIsCollab] = useState(true);
  const [isOwner, setIsOwner] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [collabs, setCollabs] = useState(null);
  const [clients, setClients] = useState(null);
  const [folders, setFolders] = useState(null);
  const [uc, setuc] = useState(0);
  const [blocksSearch, setBlocksSearch] = useState([]);
  const [activeVersion, setActiveVersion] = useState(null);
  const [fileData, setFileData] = useState([]);
  const [uniqueFileData, setUniqueFileData] = useState([]);
  const [dropdownCollaborators, setDropdownCollaborators] = useState();
  const [dropdownViewers, setDropdownViewers] = useState();
  const [accessList, setAccessList] = useState();
  const [hasAccessList, setHasAccessList] = useState();
  const [dropdownClients, setDropdownClients] = useState();
  const [hoveredNode, setHoveredNode] = useState(null);
  
  const onNodeClick = (event, node) => {
    window.location = "/page/" + node.id;
  };
  const onNodeMouseEnter = (event, node) => {
    setHoveredNode(node);
    // console.log(node);
  };
  const onNodeMouseLeave = (event, node) => {
    setHoveredNode(null);
    // hoveredNode.current = node;
  };

  const btnRef = useRef();

  const {
    isOpen: isOpenAccess,
    onOpen: onOpenAccess,
    onClose: onCloseAccess,
  } = useDisclosure();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();

  const {
    isOpen: isOpen4,
    onOpen: onOpen4,
    onClose: onClose4,
  } = useDisclosure();

  const {
    isOpen: isOpen5,
    onOpen: onOpen5,
    onClose: onClose5,
  } = useDisclosure();

  const {
    isOpen: isOpen6,
    onOpen: onOpen6,
    onClose: onClose6,
  } = useDisclosure();
  const { isOpen: isOpen7, onToggle: onToggle7 } = useDisclosure();

  const {
    isOpen: isOpen8,
    onOpen: onOpen8,
    onClose: onClose8,
  } = useDisclosure();

  const {
    isOpen: isOpen9,
    onOpen: onOpen9,
    onClose: onClose9,
  } = useDisclosure();
  const { isOpen: isOpenDrawer, onToggle: onToggleDrawer } = useDisclosure();

  const newOwner = useRef();
  const emailView = useRef();
  const folderId = useRef();
  const keepFiles = useRef();
  const keepFiles2 = useRef();
  const collabSearch = useRef();
  const projectVisibility = useRef();

  const [title, setTitle] = useState();
  const [selectedRole, setSelectedRole] = useState("Select Role");

  const [industry, setIndustry] = useState();
  const [client, setClient] = useState();
  const [visibility, setVisibility] = useState();
  const [code, setCode] = useState();
  const [sliderValue, setSliderValue] = useState(
    JSON.parse(window.localStorage.getItem("zoomSlider"))
      ? JSON.parse(window.localStorage.getItem("zoomSlider"))
      : 0
  );
  const [showTooltip, setShowTooltip] = useState(false);
  const [stateDescription, setStateDescription] = useState("");

  const handleDescriptionChange = (event) => {
    setStateDescription(event.target.value);
  };

  const editProjectHandler = () => {
    // console.log(visibility);
    fetch(
      {Url}.Url + "/edit_project/" + projectSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          title: title,
          industry: industry,
          client_name: client,
          project_code: code,
          visibility: projectVisibility.current,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            toast({
              title: "Collaborators added successfully!",
              description: "Let's continue working on this project.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
              onCloseComplete: () => {
                window.location.reload();
              },
            });
            // .then((res)=> {
            //   window.location.reload();
            // });
          } else {
            // console.log(res.data);
            toast({
              title: "Project editing failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const editProjectHandler2 = () => {
    onOpen2();
  };

  const createTemplate = () => {
    fetch(
      {Url}.Url+"/copy_project/" + projectSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          make_template: true,
          with_files: keepFiles.current.checked,
          title: projectInfo?.title,
          description: stateDescription,
          with_collabs: withCollabs.current.checked,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            toast({
              title: "Template created successfully!.",
              description: "Let's visit the template.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location = "/template/" + res.data.new_project_id;
              },
            });
          } else {
            // console.log(res.data);
            toast({
              description: "Template creation failed.",
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };
  const emailA = useRef();

  const logoutHandler = () => {
    authCtx.logout();
  };

  const deleteHandler = () => {
    fetch(
      {Url}.Url+ "/delete_project/" + projectSlug + "/",
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Deletion confirmed.",
              description: "Let's head back to the library.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location = "/library";
              },
            }).then(() => {
              window.location = "/library";
            });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const requestCollabAccess = () => {
    fetch(
      {Url}.Url+"/request_collaboration/" +
        projectSlug +
        "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Collaboration Request sent successfully!",
              description: "Let's continue working.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: "res.data.detail",
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const newOwnerHandler = () => {
    fetch(
      {Url}.Url+"/change_project_owner/" +
        projectSlug +
        "/",
      {
        method: "POST",
        body: JSON.stringify({
          new_owner: emailA.current,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "New Owner confirmed.",
              description: "Let's head back to the library.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location = "/library";
              },
            }).then(() => {
              window.location = "/library";
            });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };
  const nodeViewHandler = (e) => {
    // console.log(e);
    setCollapsedPages((prev) => {
      setShouldFetch(true);
      const updatedPages = { ...prev, [e]: !prev[e] };
      return updatedPages;
    });
  };
  const timeoutRef = useRef();

  useEffect(() => {
    // If there's already a timeout in progress, clear it

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a timeout to delay the effect
    timeoutRef.current = setTimeout(() => {
      if (collapsedPages && Object.keys(collapsedPages)?.length > 0) {
        // console.log(  sliderValue,
        //   JSON.parse(window.localStorage.getItem("zoomSlider"))
        // );
        if (
          sliderValue !== JSON.parse(window.localStorage.getItem("zoomSlider"))
        ) {
          setShouldFetch(true);
          getProjectInformation2(true);
        }
        getProjectInformation2(false);
      }
    }, 200);

    // Clean up the timeout when the effect is unmounted or re-run
    return () => {
      window.localStorage.setItem("zoomSlider", JSON.stringify(sliderValue));
      clearTimeout(timeoutRef.current);
    };
  }, [collapsedPages, sliderValue]);

  const getProjectInformation2 = (val) => {
    if (shouldFetch === false && val !== true) {
      return;
    }

    setIsloading(true);

    let collapsedIds = "";
    if (collapsedPages)
      collapsedIds = Object.entries(collapsedPages)
        .filter(([_, isCollapsed]) => isCollapsed)
        .map(([id]) => id)
        .join(",");
    // console.log(collapsedPages)
    projectInfo &&
      fetch(
        {Url}.Url+"/flowchart/" +
          projectSlug +
          "/?collapsed_pages=" +
          collapsedIds +
          "&zoom=" +
          (parseInt(sliderValue) + 100),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + authCtx.token,
          },
        }
      ).then((response) =>
        response
          .json()
          .then((data) => ({
            data: data,
            status: response.status,
          }))
          .then((res) => {
            if (res.status < 300) {
              setProjectInfo(res.data.project);
              console.log({Url}+"/flowchart/" +
              projectSlug +
              "/?collapsed_pages=" +
              collapsedIds +
              "&zoom=")

              setNodes(
                res.data.initialNodes.map((node) => {
                  // console.log(node)
                  node.data.styles = node?.style;
                  node.data.isCollapsed = collapsedPages[node.id];
                  node.type = "customNode";
                  node.data.nodeViewHandler = nodeViewHandler;
                  setIsloading(false);
                  return node;
                })
              );
              setEdges(res.data.initialEdges);
            }
          })
      );
  };
  const getProjectInformation = () => {
    setIsloading(true);

    fetch(
      {Url}.Url+"/flowchart/" +
        projectSlug +
        "/?zoom=" +
        (parseInt(sliderValue) + 100),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            // setFileData(res.data.initialNodes);

            // modified new viewed res.view_status
            setProjectInfo(res.data.project);
            // console.log(res.data.all_files);
            // console.log(res.data.all_files.length);
            res.data.all_files.map((el) => {
              // console.log(el);
              for (const key in el) {
                if (el.hasOwnProperty(key)) {
                  el[key].map((e) => {
                    // console.log(e);
                    fileData.push(e);
                  });
                }
              }
            });
            // console.log(fileData);

            fileData.forEach(function (item) {
              var i = uniqueFileData.findIndex((x) => x.id == item.id);
              if (i <= -1) {
                uniqueFileData.push({
                  id: item.id,
                  title: item.title,
                  author: item.author,
                  thumbnail: item.thumbnail,
                  created_on: item.created_on,
                  description: item.description,
                  google_doc_link: item.google_doc_link,
                  file: item.file,
                });
              }
            });
            // console.log(uniqueFileData);

            setNodes(
              res.data.initialNodes.map((node) => {
                // console.log(node);
                node.data.isCollapsed = false;
                node.data.styles = node?.style;

                node.data.nodeViewHandler = nodeViewHandler;
                node.type = "customNode";

                return node;
              })
            );
            setCollapsedPages((prev) => {
              const collapsedPages = res.data.initialNodes?.reduce(
                (result, node) => {
                  return Object.assign(result, { [node.id]: false });
                },
                {}
              );
              // console.log(collapsedPages)
              return collapsedPages;
            });

            setEdges(res.data.initialEdges);
            setIsCollab(res.data.is_collaborator);
            setIsOwner(res.data.is_owner);
            setTitle(res.data.project.title);
            setIndustry(res.data.project.industry);
            setClient(res.data.project.client_name);
            setVisibility(res.data.project.visibility);
            setCode(res.data.project.project_code);
            setIsClient(authCtx.role === "Client");
            setClient(res.data.project.client_name);
            setBlocksSearch(
              res.data.initialNodes.map(({ id, data }) => {
                let { label } = data;
                label = label.replace("🆕", "").replace("📝", "");
                // trim starting and ending characters
                label = label.trim();
                id = parseInt(id);
                return { id, name: label };
              })
            );
            setActiveVersion(null);
            setIsloading(false);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  // console.log(edges)
  // console.log(blocksSearch);
  // console.log(nodes);

  const collabHandler = () => {
    fetch(
     {Url}.Url+ "/manage_collaborators/" +
        projectSlug +
        "/",
      {
        method: "POST",
        body: JSON.stringify({
          collaborators: emailA.current,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Collaborators added successfully!",
              description: "Let's continue working on this project.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            onClose();
            setuc(uc + 1);
          } else {
            toast({
              title: "Adding collaborators failed.",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const viewerHandler = () => {
    fetch(
      {Url}.Url+"/manage_viewers/" + projectSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          viewers: emailA.current,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Viewers added successfully!",
              description: "Let's continue working on this project.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            onClose4();
            setuc(uc + 1);
          } else {
            toast({
              title: "Adding viewers failed.",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const clientHandler = () => {
    fetch(
      {Url}.Url+"/manage_clients/" + projectSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          clients: emailA.current,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Clients added successfully!",
              description: "Let's continue working on this project.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            onClose5();
            setuc(uc + 1);
          } else {
            toast({
              title: "Adding viewers failed.",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };
  const getCollabs = () => {
    fetch(
      {Url}.Url+ "/manage_collaborators/" +
        projectSlug +
        "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setCollabs(res.data.collaborators);
            setDropdownCollaborators(
              res.data.not_collaborators.map((data, id) => {
                // let { label } = data;
                // trim starting and ending characters
                id = parseInt(id);
                // return { id, name: data };
                return { id: id, name: data };
              })
            );
            // console.log(res.data.not_collaborators);
          } else {
            toast({
              title: "Adding collaborators failed.",
              description: "Something went wrong.",
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const getAccess = () => {
    fetch(
      {Url}.Url+"/manage_access/" + projectSlug + "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setAccessList(
              res.data.not_access.map(({ email }, id) => {
                // let { label } = data;
                // trim starting and ending characters
                id = parseInt(id);
                // return { id, name: data };
                return { id: id, name: email };
              })
            );
            setHasAccessList(res.data.has_access);
            // console.log(res.data.has_access);
            console.log(accessList)
          }
        })
    );
  };
  const getFolders = () => {
    fetch({Url}.Url+"/get_folder_titles/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setFolders(res.data);
            // console.log(res.data);
          } else {
            toast({
              title: "Failed to fetch folders",
              description: "Something went wrong.",
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });
          }
        })
    );
  };
  const addProjectToFolderHandler = () => {
    // console.log(folderId.current.value);
    fetch(
      {Url}.Url+"/add_remove_items_from_folder/" +
        folderId?.current.value +
        "/",
      {
        method: "POST",
        body: JSON.stringify({
          type: "project",
          item_id: projectSlug,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Project added successfully!",
              description: "Let's continue working on this project.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });

            onClose6();
            setuc(uc + 1);
          } else {
            toast({
              title: "Adding project failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });
          }
        })
    );
  };
  const getClients = () => {
    fetch(
      {Url}.Url+"/manage_clients/" + projectSlug + "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setClients(res.data.added_clients);
            // console.log(res.data);
            setDropdownClients(res.data.not_added_clients);
            // console.log(collabs);
          } else {
            toast({
              title: "Something went wrong.",
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });
          }
        })
    );
  };

  const collabRemoveHandler = (email) => {
    // let tEmail = email
    //   ? email.substring(email.indexOf("<") + 1, email.indexOf(">"))
    //   : "";
    fetch(
      {Url}.Url+"/manage_collaborators/" +
        projectSlug +
        "/",
      {
        method: "DELETE",
        body: JSON.stringify({
          collaborators: email,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Collaborator Removed successfully!",
              description: "Collaborator Removed successfully!",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });
            onClose();
            getCollabs();
            getAccess();
          } else {
            toast({
              title: "Removing collaborator failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });
          }
        })
    );
    // console.log(tEmail)
  };
  const viewerRemoveHandler = (email) => {
    // let tEmail = email
    //   ? email.substring(email.indexOf("<") + 1, email.indexOf(">"))
    //   : "";
    fetch(
      {Url}.Url+"/manage_viewers/" + projectSlug + "/",
      {
        method: "DELETE",
        body: JSON.stringify({
          viewers: email,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Viewer Removed successfully!",
              description: "Let's continue working on this project.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });

            onClose4();
            getViewers();
            getAccess();
          } else {
            toast({
              title: "Removing collaborator failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });
          }
        })
    );
    // console.log(tEmail)
  };

  const clientRemoveHandler = (email) => {
    let tEmail = email ? email : "";
    fetch(
      {Url}.Url+"/manage_clients/" + projectSlug + "/",
      {
        method: "DELETE",
        body: JSON.stringify({
          clients: tEmail,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Client Removed successfully!",
              description: "Let's continue working on this project.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });

            onClose5();
            getClients();
          } else {
            toast({
              title: "Removing Client failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
    // console.log(tEmail)
  };

  // function to copy a project
  function copyProjectHandler() {
    fetch(
      {Url}.Url+"/copy_project/" + projectSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          with_files: keepFiles2.current.checked,
          with_collabs: withCollabs2.current.checked,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Project Copied successfully!",
              description: "Let's head to the project.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location = "/project/" + res.data.new_project_id + "/";
              },
            });

            // window.location = "/project/" + res.data.project_id;
          } else {
            toast({
              title: "Copying failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });
            // swal("Copying failed.", res.data.detail, "error",{timer:2000});
          }
        })
    );
  }

  const [viewers, setViewers] = useState();

  const getViewers = () => {
    fetch(
      {Url}.Url+"/manage_viewers/" + projectSlug + "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setViewers(res.data.viewers);
            setDropdownViewers(res.data.not_viewers);
          } else {
            toast({
              title: "Adding viewers failed.",
              description: "Something went wrong.",
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });

            // swal("Adding viewers failed.", "Something went wrong.", "error",{timer:2000});
          }
        })
    );
  };

  const linkPage = (child, parent) => {
    fetch({Url}.Url+"/link_pages/", {
      method: "POST",
      body: JSON.stringify({
        page_id: child,
        depends_on: parent,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            getProjectInformation();
            // console.log(res.data);
          } else {
            toast({
              title: "Something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              position: "top-right",
            });

            // swal("Something went wrong!", res.data.detail, "error",{timer:2000});
          }
        })
    );
  };
  const deleteLink = (type, child, parent) => {
    fetch({Url}.Url+"/delete_page_links/", {
      method: "POST",
      body: JSON.stringify({
        type: type,
        page_id: parent,
        deleted_id: child,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            getProjectInformation();
            // console.log(res.data);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal("Oops, something went wrong!", res.data.detail, "error",{timer:2000});
          }
        })
    );
  };
  const nodeColor = (node) => {
    switch (node.style.backgroundColor) {
      case "#984444":
        return "#ff0072";
      case "#2C6D3E":
        return "#6ede87";
      default:
        return "#5c6e7a ";
    }
  };

  const handleSlider = (value) => {
    // console.log(value);

    setSliderValue(value);
    switch (value) {
      case 0: {
        fontChangeHandler(150, 13);
        break;
      }
      case 20: {
        fontChangeHandler(167, 16);
        break;
      }

      case 40: {
        fontChangeHandler(182, 19);
        break;
      }
      case -20: {
        fontChangeHandler(150, 10);
        break;
      }
      case 60: {
        fontChangeHandler(195, 23);
        break;
      }
      case 80: {
        fontChangeHandler(200, 26);
        break;
      }
      default: {
        break;
      }
    }
  };

  const fontChangeHandler = (width, value) => {
    if (nodes && nodes[0].style) {
      setNodes(
        nodes.map((node) => {
          node.style = {
            ...node.style,
            fontSize: value,
          };
          node.data.styles = node.style;
          return node;
        })
      );
    }
  };

  // nodes && console.log(nodes);
  // runs on initial page load
  useEffect(() => {
    getProjectInformation();
    getCollabs();
    getClients();
    getFolders();
    getAccess();
    getViewers();
    // setProjectInfo(data.project);
    // setNodes(data.initialNodes);
    // setEdges(data.initialEdges);
    // eslint-disable-next-line
  }, []);
  // useEffect(()=>{
  //   if(projectInfo){
  //     if (
  //       projectInfo?.role?.toLowerCase() !== "viewer" &&
  //       projectInfo?.role?.toLowerCase() !== "client"
  //     ) {
  //       getVersions();
  //     }
  //   }
  // },[projectInfo])

  // useEffect(() => {
  //   window.localStorage.setItem("zoomSlider", JSON.stringify(sliderValue));
  //   // console.log(sliderValue);
  // }, [sliderValue]);

  useEffect(() => {
    nodes.length > 0 && handleSlider(sliderValue);
  }, [edges]);

  useEffect(() => {
    getCollabs();
    getClients();
    getViewers();
    getFolders();
    getAccess();
    // eslint-disable-next-line
  }, [uc]);

  // autocomplete search implementation
  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results);
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result);
  };

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item);
    window.location = "/page/" + item.id;
  };

  const handleOnFocus = () => {
    // console.log("Focused");
  };

  const formatResult = (item) => {
    // console.log(item);
    return (
      <div className="result-wrapper">
        <span className="result-span">id: {item.id}</span>
        <span className="result-span">name: {item.name}</span>
      </div>
    );
  };
  const searchOnClickHandler = (e) => {
    e();
  };
  const [isLargerThan1000] = useMediaQuery("(min-width: 1000px)");
  // shortcuts in library page
  useHotkeys("alt+x", () => (window.location = "/library"));
  useHotkeys("option+x", () => (window.location = "/library"));
  useHotkeys("alt+c", () => onOpen9());
  useHotkeys("option+c", () => onOpen9());
  useHotkeys("alt+n", () => openInNewTab("/new-page/" + projectSlug));
  useHotkeys("option+n", () => openInNewTab("/new-page/" + projectSlug));
  const breadcrumbs = [
    { path: "/", breadcrumb: "Home" },
    { path: "/library", breadcrumb: "Library" },
  ];

  const accessHandler = (e) => {
    if (selectedRole === "Viewer") {
      viewerHandler();
    } else if (selectedRole === "Collaborator") {
      collabHandler();
    } else if (selectedRole === "Client") {
      clientHandler();
    } else if (selectedRole === "Owner") {
      newOwnerHandler();
    }
    setSelectedRole("Select Role");
  };

  const filePreviewHandler = (val) => {
    setShowFilePreview(() => {
      let v = val;
      window.localStorage.setItem("filePreview", JSON.stringify(v));
      return v;
    });
    window.location.reload();
  };
  const [versions, setVersions] = useState([]);

  const getVersions = () => {
    fetch(
      {Url}.Url+"/get_project_versions/" +
        projectSlug +
        "/",
      {
        method: "GET",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setVersions(res.data);
            // setComments(() => {
            //   const data = res.data;
            //   setLoading(false);
            //   return data;
            // });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const restoreVersion = (versionId) => {
    fetch(
      {Url}.Url+"/restore_project_version/" +
        projectSlug +
        "/",
      {
        method: "POST",
        body: JSON.stringify({
          version_id: versionId,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            window.location.reload();
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const putVersion = () => {
    fetch(
      {Url}.Url+"/backup_project/" + projectSlug + "/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            window.location.reload();
            // setComments(() => {
            //   const data = res.data;
            //   setLoading(false);
            //   return data;
            // });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const getVersion = (versionId) => {
    setIsloading(true);

    fetch(
      {Url}.Url+"/version_flowchart/" +
        projectSlug +
        "/?version_id=" +
        versionId +
        "&zoom=" +
        (parseInt(sliderValue) + 100),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(nodes);
            // console.log(res.data);

            setNodes(
              res.data.initialNodes.map((node) => {
                // console.log(node?.status);
                node.data.styles = node?.style;
                if (node?.status === "changed") {
                }
                node.data.isCollapsed = true;
                node.type = "customNode";
                node.data.isVersion = true;
                node.data.nodeViewHandler = nodeViewHandler;
                // console.log(node);
                setIsloading(false);
                return node;
              })
            );
            setEdges(res.data.initialEdges);

            // setComments(() => {
            //   const data = res.data;
            //   setLoading(false);
            //   return data;
            // });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };
  const versionClickHandler = (versionId) => {
    if (activeVersion === versionId) {
      setActiveVersion(null);
      getProjectInformation();
    } else {
      setActiveVersion(versionId);
      getVersion(versionId);
    }
  };

  useEffect(()=>{
    getProjectInformation();
    // if(fav)
    // setColorFont('yellow');
    // else
    // setColorFont('green');
  
}, [fav])

  const setFavorites = () => {
    console.log(projectInfo.favorite)
    console.log({Url}.Url)
    if(projectInfo.favorite){
      fetch(
        {Url}.Url+"/remove_project_from_favorite/" +
             projectSlug +
             "/",
             {
               method: "POST",
               body: JSON.stringify({
                 version_id: activeVersion,
               }),
               headers: {
                 "Content-Type": "application/json",
                 Authorization: "Token " + authCtx.token,
               },
             }
       ).then((response) =>
       response
         .json()
         .then((data) => ({
           data: data,
           status: response.status,
         }))
         .then((res) => {
           console.log(res);
          //  toggleColorMode();
          // setFav(projectInfo.favorite)
          setFav(false);
          console.log(projectInfo.favorite, "change")
           setColorFont('white');
           toast({
            title: "Removed from Favorites!",
            description: "Done!",
            status: "success",
            duration: 2000,
            isClosable: true,
            position: "top-right",
          });
         })
        
     );
    } else {
      fetch(
        {Url}.Url+"/add_project_to_favorite/" +
             projectSlug +
             "/",
             {
               method: "POST",
               body: JSON.stringify({
                 version_id: activeVersion,
               }),
               headers: {
                 "Content-Type": "application/json",
                 Authorization: "Token " + authCtx.token,
               },
             }
       ).then((response) =>
       response
         .json()
         .then((data) => ({
           data: data,
           status: response.status,
         }))
         .then((res) => {
           console.log(res);
          //  toggleColorMode();
          setFav(true);
          console.log(projectInfo.favorite, "change")
           setColorFont('yellow');
           toast({
            title: "Added to Favorites!",
            description: "Done!",
            status: "success",
            duration: 2000,
            isClosable: true,
            position: "top-right",
           
          });
         })
     );
    }


  }
  const renderFavorite = () => {
    if(authCtx){
      return (
        <Button
                          bg="#444d54"
                          justifyContent={"left"}
                          // color="white"
                          fontSize="16px"
                          _hover={{
                            background: "transparent",
                          }}
                          mr="10px"
                          height="1.9rem"
                          onClick={()=>{ setFavorites();}}
                        >
                         
                          &nbsp; 
                          {/* <AiOutlineStar /> */}
                          {/* <BsStar color={colorFont}  /> */}
                          {projectInfo.favorite?<><BsFillStarFill color='#C1962F' /></>:<><BsStar color='#fff'  /></>}
                        </Button>
      )
    }
  }
  const createProjectHandler = () => {
    if (activeVersion)
      fetch(
        {Url}.Url+"/create_project_from_version/" +
          projectSlug +
          "/",
        {
          method: "POST",
          body: JSON.stringify({
            version_id: activeVersion,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + authCtx.token,
          },
        }
      ).then((response) =>
        response
          .json()
          .then((data) => ({
            data: data,
            status: response.status,
          }))
          .then((res) => {
            if (res.status < 300) {
              toast({
                title: "Project Created!",
                description: "Project created successfully",
                status: "success",
                duration: 2000,
                isClosable: true,
                position: "top-right",
                onCloseComplete: () => {
                  window.location = "/project/" + res.data.project_id + "/";
                },
              });
            } else {
              toast({
                title: "Oops, something went wrong!",
                description: res.data.detail,
                status: "error",
                duration: 2000,
                isClosable: true,
                position: "top-right",
              });
              // swal("Oops, something went wrong!", res.data.detail, "error",{timer: 2000});
            }
          })
      );
  };

  const [summary, setSummary] = useState("");

  const getSummaryHandler = () => {
    onOpen8();
    
    setSummary(null);

    fetch(
      {Url}.Url+"/summarize/?type=project&id=" +
        projectSlug,
      {
        method: "GET",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setSummary(res.data.summary);
          } else {
            // toast({
            //   title: "Oops, something went wrong!",
            //   description: res.data.detail,
            //   status: "error",
            //   duration: 2000,
            //   isClosable: true,
            //   position: "top-right",
            // });
            generateSummaryHandler();
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const generateSummaryHandler = () => {
    
    setSummary(null);
    fetch(
      {Url}.Url+"/summarize/?type=project&id=" +
        projectSlug,
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            console.log(res.data);
            setSummary(res.data.summary);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };
 const reactFlowWrapper = useRef(null);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);


  const onLoad = (reactFlowInstance) => {
    setReactFlowInstance(reactFlowInstance);
    const storedViewport = JSON.parse(sessionStorage.getItem(`viewport-${projectSlug}`));
    console.log(storedViewport);
    if (storedViewport) {
      const { x, y, zoom } = storedViewport;
      reactFlowInstance.setViewport(storedViewport);
      // reactFlowInstance.zoomTo(zoom);
    }
    else{
      reactFlowInstance.fitView();
    }

  };
  return (
    <>
      <Flex
        backgroundColor="bg"
        flexDir="column"
        alignItems="center"
        minHeight="100vh"
        width="100vw"
        pr={isOpen7 || isOpenDrawer ? "270px" : "0%"}
        transition="all 0.3s ease"
      >
        {projectInfo ? (
          <Flex
            width={{ base: "97%", md: "96%" }}
            height="fit-content"
            flexDir="column"
            justifyContent="space-between"
          >
            <>
              <Flex
                width={["99%", "99%", "100%", "100%", "100%"]}
                flexDir="column"
                mr="10px"
              >
                <Flex
                  flexDir={{ base: "column", md: "row" }}
                  justifyContent={{ md: "space-between" }}
                  alignItems={{ md: "center" }}
                  borderBottom="2px solid  rgba(255, 255, 255, 0.24)"
                >
                  <Flex flexDir="column">
                    <Flex
                      w="100%"
                      color="white"
                      fontWeight="400"
                      alignItems="center"
                      justifyContent={"start"}
                      mt={2}
                    >
                      {projectInfo && <Breadcrumbs breadcrumbs={breadcrumbs} />}
                      <Flex flexDir="row" alignItems="center">
                        <Text
                          color="main.text"
                          fontSize={{ md: "20px" }}
                          fontWeight="900"
                        >
                          {projectInfo.title}
                        </Text>

                        {isOwner || isCollab ? (
                          <>
                          <Text
                            onClick={editProjectHandler2}
                            cursor="pointer"
                            ml="10px"
                          >
                            <svg
                              width="18"
                              height="20"
                              viewBox="0 0 22 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.393 6.868C20.897 6.364 21.1743 5.69467 21.1743 4.98267C21.1743 4.27067 20.897 3.60133 20.393 3.09733L18.2783 0.982665C17.7743 0.478665 17.105 0.201332 16.393 0.201332C15.681 0.201332 15.0117 0.478665 14.509 0.981332L0.333008 15.1133V21H6.21701L20.393 6.868ZM16.393 2.868L18.509 4.98133L16.389 7.09333L14.2743 4.98L16.393 2.868ZM2.99967 18.3333V16.22L12.3863 6.86266L14.501 8.97733L5.11567 18.3333H2.99967ZM0.333008 23.6667H21.6663V26.3333H0.333008V23.6667Z"
                                fill="#FFC949"
                              />
                            </svg>
                          </Text>
                          
  </>
                        ) : null}
                        {/* <Button direction='row' align='center'
                          fontSize={{ md: "20px" }}
                          fontWeight="900" display="inline" onClick={()=>{ setFavorites(); }} color={colorFont}  mb='0'>
  &nbsp; <StarIcon />
  </Button> */}
                      </Flex>
                    </Flex>
                    <Flex flexDir="row" alignItems="center" pb={1} mt={1}>
                      <Avatar
                        size="xs"
                        bg="white"
                        name={projectInfo?.project_owner.name}
                        src={projectInfo?.project_owner.name}
                        color="#2D3842"
                        fontWeight="700"
                        mr={2}
                      />
                      <Text fontSize="13px" color="white">
                        {projectInfo?.project_owner.name + " "}
                        <Text
                          borderRight="2px solid #FFFFFF3D"
                          display="inline"
                        >
                          &nbsp;
                        </Text>{" "}
                        &nbsp; Last modified{" "}
                        {" " + projectInfo.last_modified.split("T")[0]}{" "}
                        <Text
                          borderRight="2px solid #FFFFFF3D"
                          display="inline"
                        >
                          &nbsp;
                        </Text>
                        &nbsp;{" "}
                        {projectInfo.last_modified
                          .split("T")[1]
                          .split(".")[0]
                          .slice(0, 5)}
                        {"  "}
                        &nbsp;
                        <Text borderLeft="2px solid #FFFFFF3D" display="inline">
                          &nbsp;
                          {projectInfo?.role?.toUpperCase() + " "}
                        </Text>
                        <Text
                          borderLeft="2px solid #FFFFFF3D"
                          display="inline"
                          ml="1"
                          onClick={() => {
                            getSummaryHandler();
                          }}
                          _hover={{ cursor: "pointer" ,
                          color:"main.text"}}
                        >
                          &nbsp; 
                          Summary
                          &nbsp; 

                          <svg
                          style={{display:"inline",transform:"translateY(2px)"}}
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            height="16"
                            width="16"
                            
                          >
                            <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 001.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 00-1.828 1.829l-.645 1.936a.361.361 0 01-.686 0l-.645-1.937a2.89 2.89 0 00-1.828-1.828l-1.937-.645a.361.361 0 010-.686l1.937-.645a2.89 2.89 0 001.828-1.828l.645-1.937zM3.794 1.148a.217.217 0 01.412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 010 .412l-1.162.387A1.734 1.734 0 004.593 5.69l-.387 1.162a.217.217 0 01-.412 0L3.407 5.69A1.734 1.734 0 002.31 4.593l-1.162-.387a.217.217 0 010-.412l1.162-.387A1.734 1.734 0 003.407 2.31l.387-1.162zM10.863.099a.145.145 0 01.274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 010 .274l-.774.258a1.156 1.156 0 00-.732.732l-.258.774a.145.145 0 01-.274 0l-.258-.774a1.156 1.156 0 00-.732-.732L9.1 2.137a.145.145 0 010-.274l.774-.258c.346-.115.617-.386.732-.732L10.863.1z" />
                          </svg>
                        </Text>
                        
                      </Text>
                    </Flex>
                  </Flex>
                  
                  {authCtx.role !== "Client" && (isCollab || isOwner) ? (
                    <Flex
                      flexDir={{ md: "column" }}
                      alignItems={{ md: "end" }}
                      my={1}
                    >
                      <Flex my={{ md: 1 }}>
                      
                        
                        <Button
                          bg="background.yellow1"
                          width={{ md: "160px" }}
                          p={1}
                          mr={2}
                          color="white"
                          fontSize="13px"
                          // mr="10px"
                          as="a"
                          height="1.9rem"
                          href={"/new-page/" + projectSlug}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                              fill="white"
                            />
                            <path
                              d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                              fill="white"
                            />
                          </svg>
                          &nbsp; {isLargerThan1000 ? "Create a New Block" : ""}
                        </Button>
                        <Button
                          ref={btnRef}
                          bg="#444d54"
                          p={1}
                          px={2}
                          color="white"
                          ml={1}
                          width={"max-content"}
                          fontSize="13px"
                          // mr="10px"
                          as="a"
                          height="1.9rem"
                          onClick={() => {
                            onToggleDrawer();
                          }}
                        >
                          <svg
                            fill="none"
                            width="16"
                            height="16"
                            viewBox="0 0 18 18"
                          >
                            <path
                              fill="currentColor"
                              d="M0 4.5V0h1v4.5a1.5 1.5 0 103 0v-3a.5.5 0 00-1 0V5H2V1.5a1.5 1.5 0 113 0v3a2.5 2.5 0 01-5 0z"
                            />
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M12.5 0H6v4.5A3.5 3.5 0 012.5 8H1v5.5A1.5 1.5 0 002.5 15h10a1.5 1.5 0 001.5-1.5v-12A1.5 1.5 0 0012.5 0zM11 4H7v1h4V4zm0 3H7v1h4V7zm-7 3h7v1H4v-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                          &nbsp;
                        </Button>
                        {
                          <Button
                            bg="#444d54"
                            p={1}
                            px={2}
                            color="white"
                            ml={1}
                            width={"max-content"}
                            fontSize="13px"
                            // mr="10px"
                            as="a"
                            height="1.9rem"
                            onClick={() => {
                              onToggle7();
                              getVersions();
                            }}
                          >
                            <svg
                              width="48"
                              height="18"
                              viewBox="0 0 24 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0 2C0 1.60218 0.158035 1.22064 0.43934 0.93934C0.720644 0.658035 1.10218 0.5 1.5 0.5H22.5C22.8978 0.5 23.2794 0.658035 23.5607 0.93934C23.842 1.22064 24 1.60218 24 2V5C24 5.39782 23.842 5.77936 23.5607 6.06066C23.2794 6.34196 22.8978 6.5 22.5 6.5V17.75C22.5 18.7446 22.1049 19.6984 21.4016 20.4016C20.6984 21.1049 19.7446 21.5 18.75 21.5H5.25C4.25544 21.5 3.30161 21.1049 2.59835 20.4016C1.89509 19.6984 1.5 18.7446 1.5 17.75V6.5C1.10218 6.5 0.720644 6.34196 0.43934 6.06066C0.158035 5.77936 0 5.39782 0 5V2ZM3 6.5V17.75C3 18.3467 3.23705 18.919 3.65901 19.341C4.08097 19.7629 4.65326 20 5.25 20H18.75C19.3467 20 19.919 19.7629 20.341 19.341C20.7629 18.919 21 18.3467 21 17.75V6.5H3ZM22.5 2H1.5V5H22.5V2ZM7.5 10.25C7.5 10.0511 7.57902 9.86032 7.71967 9.71967C7.86032 9.57902 8.05109 9.5 8.25 9.5H15.75C15.9489 9.5 16.1397 9.57902 16.2803 9.71967C16.421 9.86032 16.5 10.0511 16.5 10.25C16.5 10.4489 16.421 10.6397 16.2803 10.7803C16.1397 10.921 15.9489 11 15.75 11H8.25C8.05109 11 7.86032 10.921 7.71967 10.7803C7.57902 10.6397 7.5 10.4489 7.5 10.25Z"
                                fill="white"
                              />
                            </svg>
                          </Button>
                        }
                      </Flex>
                     
                      <Flex flexDir={"row"}>
                     
                        
                      <Button
                          bg="#444d54"
                          justifyContent={"left"}
                          // color="white"
                          fontSize="16px"
                          _hover={{
                            background: "transparent",
                          }}
                          mr="10px"
                          height="1.9rem"
                          onClick={()=>{ setFavorites();}}
                        >
                         
                          &nbsp; 
                          {/* <AiOutlineStar /> */}
                          {/* <BsStar color={colorFont}  /> */}
                          {projectInfo.favorite?<><BsFillStarFill color='#C1962F' /></>:<><BsStar color='#fff'  /></>}
                        </Button>
                        
                        <Button
                          bg="#444d54"
                          justifyContent={"left"}
                          color="white"
                          fontSize="13px"
                          _hover={{
                            background: "#F2DBA6",
                          }}
                          mr="10px"
                          height="1.9rem"
                          onClick={onOpenAccess}
                        >
                          <svg
                            width="15"
                            height="14"
                            viewBox="0 0 19 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.4528 12.5961C11.4176 12.5612 11.37 12.5416 11.3204 12.5416C11.2708 12.5416 11.2232 12.5612 11.188 12.5961L8.46455 15.3195C7.20361 16.5804 5.07549 16.714 3.6833 15.3195C2.28877 13.925 2.42236 11.7992 3.6833 10.5383L6.40674 7.81482C6.47939 7.74217 6.47939 7.62264 6.40674 7.54998L5.47393 6.61717C5.43869 6.58227 5.3911 6.5627 5.3415 6.5627C5.29191 6.5627 5.24432 6.58227 5.20908 6.61717L2.48564 9.3406C0.502832 11.3234 0.502832 14.532 2.48564 16.5125C4.46846 18.4929 7.67705 18.4953 9.65752 16.5125L12.381 13.789C12.4536 13.7164 12.4536 13.5969 12.381 13.5242L11.4528 12.5961ZM17.5138 1.4867C15.531 -0.496115 12.3224 -0.496115 10.3419 1.4867L7.61611 4.21014C7.58122 4.24538 7.56164 4.29296 7.56164 4.34256C7.56164 4.39215 7.58122 4.43974 7.61611 4.47498L8.54658 5.40545C8.61924 5.4781 8.73877 5.4781 8.81143 5.40545L11.5349 2.68201C12.7958 1.42107 14.9239 1.28748 16.3161 2.68201C17.7106 4.07654 17.5771 6.20232 16.3161 7.46326L13.5927 10.1867C13.5578 10.2219 13.5382 10.2695 13.5382 10.3191C13.5382 10.3687 13.5578 10.4163 13.5927 10.4515L14.5255 11.3844C14.5981 11.457 14.7177 11.457 14.7903 11.3844L17.5138 8.66092C19.4942 6.6781 19.4942 3.46951 17.5138 1.4867ZM12.2989 5.72654C12.2637 5.69165 12.2161 5.67207 12.1665 5.67207C12.1169 5.67207 12.0693 5.69165 12.0341 5.72654L6.72549 11.0328C6.69059 11.068 6.67102 11.1156 6.67102 11.1652C6.67102 11.2148 6.69059 11.2624 6.72549 11.2976L7.65361 12.2258C7.72627 12.2984 7.8458 12.2984 7.91846 12.2258L13.2247 6.91951C13.2974 6.84685 13.2974 6.72732 13.2247 6.65467L12.2989 5.72654Z"
                              fill="white"
                            />
                          </svg>{" "}
                          &nbsp; Access
                        </Button>
                        <Menu>
                          <MenuButton>
                            <Button
                              bg="#444d54"
                              justifyContent={"left"}
                              color="white"
                              height="1.9rem"
                              fontSize="13px"
                              _hover={{
                                background: "#F2DBA6",
                              }}
                              // mr="10px"
                            >
                              <svg
                                width="22"
                                height="20"
                                viewBox="0 0 22 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19.8187 14.2469C18.8226 13.6703 17.6085 13.825 16.7906 14.5469L15.5484 13.8273V10.2719C15.5484 9.90391 15.3515 9.56172 15.0328 9.37891L11.8453 7.54375V5.97109C12.8812 5.61953 13.6265 4.63984 13.6265 3.48438C13.6265 2.03359 12.4523 0.859375 11.0015 0.859375C9.55073 0.859375 8.37651 2.03359 8.37651 3.48438C8.37651 4.63984 9.12183 5.61953 10.1578 5.97109V7.54375L6.97026 9.37891C6.65151 9.56172 6.45464 9.90391 6.45464 10.2719V13.825L5.21245 14.5445C4.39448 13.8227 3.17808 13.668 2.18433 14.2445C0.93042 14.9711 0.503858 16.5742 1.22339 17.8281C1.94526 19.082 3.54136 19.5133 4.79058 18.7891C5.78667 18.2125 6.26011 17.0781 6.04683 16.0047L7.18823 15.3414L10.4835 17.2398C10.6429 17.3313 10.821 17.3781 10.9992 17.3781C11.1773 17.3781 11.3554 17.3313 11.5148 17.2398L14.8078 15.3438L15.9492 16.007C15.7359 17.0781 16.2117 18.2148 17.2054 18.7914C18.4546 19.5156 20.0531 19.0867 20.7726 17.8305C21.4945 16.5742 21.0679 14.9711 19.8187 14.2469ZM4.04526 17.4906C3.91796 17.5644 3.77733 17.6122 3.63148 17.6313C3.48562 17.6505 3.33741 17.6406 3.19538 17.6023C3.05335 17.564 2.92031 17.4979 2.80391 17.408C2.68751 17.318 2.59005 17.2059 2.51714 17.0781C2.20776 16.5414 2.39058 15.8523 2.9273 15.543C3.0546 15.4692 3.19522 15.4214 3.34108 15.4022C3.48694 15.3831 3.63515 15.3929 3.77718 15.4313C3.91921 15.4696 4.05225 15.5357 4.16865 15.6256C4.28505 15.7156 4.38251 15.8277 4.45542 15.9555C4.7648 16.4922 4.58198 17.1812 4.04526 17.4906ZM9.87417 3.48438C9.88018 3.18998 10.0013 2.90968 10.2117 2.7036C10.422 2.49753 10.7047 2.38211 10.9992 2.38211C11.2936 2.38211 11.5763 2.49753 11.7867 2.7036C11.997 2.90968 12.1182 3.18998 12.1242 3.48438C12.1182 3.77877 11.997 4.05907 11.7867 4.26515C11.5763 4.47122 11.2936 4.58664 10.9992 4.58664C10.7047 4.58664 10.422 4.47122 10.2117 4.26515C10.0013 4.05907 9.88018 3.77877 9.87417 3.48438ZM13.8585 13.9422L10.9992 15.5898L8.1398 13.9422V10.6516L10.9992 9.00391L13.8585 10.6516V13.9422ZM19.4812 17.0805C19.1718 17.6172 18.4875 17.8023 17.9531 17.493C17.4187 17.1836 17.2335 16.4945 17.5429 15.9578C17.8523 15.4211 18.5367 15.2359 19.071 15.5453C19.6078 15.8547 19.7906 16.5414 19.4812 17.0805Z"
                                  fill="white"
                                />
                              </svg>
                              &nbsp; More Actions
                            </Button>
                          </MenuButton>

                          <MenuList>
                            <MenuItem onClick={onOpen9}>
                              Copy Project
                            </MenuItem>
                            <MenuItem onClick={onOpen6}>Add to folder</MenuItem>
                            <MenuItem
                              onClick={() =>
                                openInNewTab(projectInfo?.drive_link)
                              }
                            >
                              View Drive
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                (window.location =
                                  "/trash-blocks/" + projectSlug + "/")
                              }
                            >
                              View Trash
                            </MenuItem>
                            <MenuItem onClick={onOpen3}>Make Template</MenuItem>
                            {isOwner && (
                              <MenuItem onClick={deleteHandler}>
                                {" "}
                                Move to Trash
                              </MenuItem>
                            )}
                          </MenuList>
                        </Menu>
                      </Flex>
                      {!isCollab && !isOwner && (
                        <Button
                          cursor="pointer"
                          mx="10px"
                          bottom="0"
                          bg="#4B555E"
                          // maxW="100%"
                          // minW="220px"
                          color="white"
                          fontSize="13px"
                          _hover={{
                            background: "#F2DBA6",
                          }}
                          mr="10px"
                          onClick={requestCollabAccess}
                        >
                          <svg
                            width="15"
                            height="14"
                            viewBox="0 0 19 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.4528 12.5961C11.4176 12.5612 11.37 12.5416 11.3204 12.5416C11.2708 12.5416 11.2232 12.5612 11.188 12.5961L8.46455 15.3195C7.20361 16.5804 5.07549 16.714 3.6833 15.3195C2.28877 13.925 2.42236 11.7992 3.6833 10.5383L6.40674 7.81482C6.47939 7.74217 6.47939 7.62264 6.40674 7.54998L5.47393 6.61717C5.43869 6.58227 5.3911 6.5627 5.3415 6.5627C5.29191 6.5627 5.24432 6.58227 5.20908 6.61717L2.48564 9.3406C0.502832 11.3234 0.502832 14.532 2.48564 16.5125C4.46846 18.4929 7.67705 18.4953 9.65752 16.5125L12.381 13.789C12.4536 13.7164 12.4536 13.5969 12.381 13.5242L11.4528 12.5961ZM17.5138 1.4867C15.531 -0.496115 12.3224 -0.496115 10.3419 1.4867L7.61611 4.21014C7.58122 4.24538 7.56164 4.29296 7.56164 4.34256C7.56164 4.39215 7.58122 4.43974 7.61611 4.47498L8.54658 5.40545C8.61924 5.4781 8.73877 5.4781 8.81143 5.40545L11.5349 2.68201C12.7958 1.42107 14.9239 1.28748 16.3161 2.68201C17.7106 4.07654 17.5771 6.20232 16.3161 7.46326L13.5927 10.1867C13.5578 10.2219 13.5382 10.2695 13.5382 10.3191C13.5382 10.3687 13.5578 10.4163 13.5927 10.4515L14.5255 11.3844C14.5981 11.457 14.7177 11.457 14.7903 11.3844L17.5138 8.66092C19.4942 6.6781 19.4942 3.46951 17.5138 1.4867ZM12.2989 5.72654C12.2637 5.69165 12.2161 5.67207 12.1665 5.67207C12.1169 5.67207 12.0693 5.69165 12.0341 5.72654L6.72549 11.0328C6.69059 11.068 6.67102 11.1156 6.67102 11.1652C6.67102 11.2148 6.69059 11.2624 6.72549 11.2976L7.65361 12.2258C7.72627 12.2984 7.8458 12.2984 7.91846 12.2258L13.2247 6.91951C13.2974 6.84685 13.2974 6.72732 13.2247 6.65467L12.2989 5.72654Z"
                              fill="white"
                            />
                          </svg>{" "}
                          &nbsp; Request Collaboration Access
                        </Button>
                      )}
                    </Flex>
                  ):(<Flex justifyContent="flex-end"><Button
                          bg="#444d54"
                          justifyContent={"left"}
                          // color="white"
                          fontSize="16px"
                          _hover={{
                            background: "transparent",
                          }}
                          mr="10px"
                          height="1.9rem"
                          onClick={()=>{ setFavorites();}}
                        >
                         
                          &nbsp; 
                          {/* <AiOutlineStar /> */}
                          {/* <BsStar color={colorFont}  /> */}
                          {projectInfo.favorite?<><BsFillStarFill color='#C1962F' /></>:<><BsStar color='#fff'  /></>}
                        </Button>
                        <Button
                          ref={btnRef}
                          bg="#444d54"
                          p={1}
                          px={2}
                          color="white"
                          ml={1}
                          width={"max-content"}
                          fontSize="13px"
                          // mr="10px"
                          as="a"
                          height="1.9rem"
                          onClick={() => {
                            onToggleDrawer();
                          }}
                        >
                          <svg
                            fill="none"
                            width="16"
                            height="16"
                            viewBox="0 0 18 18"
                          >
                            <path
                              fill="currentColor"
                              d="M0 4.5V0h1v4.5a1.5 1.5 0 103 0v-3a.5.5 0 00-1 0V5H2V1.5a1.5 1.5 0 113 0v3a2.5 2.5 0 01-5 0z"
                            />
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M12.5 0H6v4.5A3.5 3.5 0 012.5 8H1v5.5A1.5 1.5 0 002.5 15h10a1.5 1.5 0 001.5-1.5v-12A1.5 1.5 0 0012.5 0zM11 4H7v1h4V4zm0 3H7v1h4V7zm-7 3h7v1H4v-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                          &nbsp;
                        </Button>
                        </Flex>)}
                </Flex>

                <Flex
                  height="fit-content"
                  flexDir="column"
                  justifyContent="space-between"
                  // mt="20px"
                >
                  {/* <Text color="white" fontWeight="700" fontSize="20px">
              Project Pyramid
            </Text> */}
                  <Flex
                    width={{ base: "98%", md: "100%" }}
                    flexDir="row"
                    justifyContent="space-between"
                    minHeight="82vh"
                    ref={reactFlowWrapper}
                  >
                    {!loading ? (
                      <ReactFlow
                      onInit={onLoad}
                        nodes={nodes}
                        nodeTypes={nodeTypes}
                        edges={edges}
                        proOptions={{ hideAttribution: true }}
                        // onNodeMouseEnter={captureElementClick ? onNodeMouseEnter : undefined}
                        // onNodeMouseLeave={captureElementClick ? onNodeMouseLeave : undefined}
                        onConnect={onConnect} // Disable onConnect when activeVersion is defined
                        onEdgeUpdateStart={onEdgeUpdateStart}
                        onEdgeUpdateEnd={onEdgeUpdateEnd}
                        nodesConnectable={activeVersion === null}
                        edgesUpdatable={activeVersion === null}
                        onEdgeUpdate={
                          activeVersion === null ? onEdgeUpdate : undefined
                        } // Disable onEdgeUpdate when activeVersion is defined
                        // use this kind of code to create a custom menu for the edge
                        // onEdgeContextMenu={(e, edge) =>{

                        //   e.preventDefault();
                        //   console.log("edge context menu", edge)
                        // }
                        // }
                        style={{ fontWeight: "700 " }}
                        panOnScroll={true}
                      >
                      <ViewportLogger />

                        <Flex mt="2" p="12px" width="100px">
                          <Slider
                            defaultValue={sliderValue}
                            min={-20}
                            max={80}
                            step={20}
                            zIndex="10"
                            aria-label="slider-ex-3"
                            orientation="vertical"
                            minH="40"
                            onChange={handleSlider}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          >
                            <SliderTrack>
                              <Box position="relative" right={10} />
                              <SliderFilledTrack bg="#C3962C" />
                            </SliderTrack>
                            <Tooltip
                              hasArrow
                              bg="#444d54"
                              color="white"
                              placement="right"
                              isOpen={showTooltip}
                              label={`${100 + sliderValue}%`}
                            >
                              <SliderThumb boxSize={5} bg="#C3962C" />
                            </Tooltip>
                          </Slider>
                          {/* {hoveredNode &&  isLargerThan1000&& (
                        <Flex
                          bg="#444d54"
                          minWidth="350px"
                          padding="12px"
                          color="white"
                          fontSize="16px"
                          flexDirection="column"
                          // borderRadius="5px"
                          float="right"
                          zIndex="10000"
                          right="0"
                          // mt="10px"
                          position="absolute"
                        >
                          <Text>{hoveredNode && `Title:  ${hoveredNode.data.label}`}</Text>
                          <Text>{hoveredNode ? `Author:  ${hoveredNode.data.author}` : ''}</Text>
                          <Text>
                            {hoveredNode
                              ? `Files:  ${
                                  hoveredNode.data.files.length > 0
                                    ? hoveredNode.data.files.toString().length > 50
                                      ? hoveredNode.data.files.join(' , ').substring(0, 50) + '...'
                                      : hoveredNode.data.files.join(' , ')
                                    : 'NONE'
                                }`
                              : ''}
                          </Text>
                        </Flex>
                      )} */}
                        </Flex>
                        {isLargerThan1000 && (
                          <MiniMap
                            style={{
                              height: "150",
                              width: "260",
                              zIndex: "999",
                            }}
                            nodeStrokeWidth={3}
                            zoomable
                            nodeBorderRadius={5}
                            nodeColor={nodeColor}
                            pannable
                            maskStrokeColor="rgb(0,0,0, 0.4)"
                            maskColor="rgb(0,0,0, 0.1)"
                          />
                        )}
                        <Background />
                        <FormControl
                          display="flex"
                          alignItems="center"
                          zIndex="999"
                          width="fit-content"
                        >
                          <Tooltip
                            label={"Show File Preview"}
                            placement="top"
                            hasArrow
                          >
                            <Flex>
                              <Switch
                                p={1}
                                css={{
                                  "& > span:first-of-type": {
                                    backgroundColor: showFilePreview
                                      ? "#C19630"
                                      : "#A0AEC0",
                                  },
                                }}
                                id="show-file-preview"
                                isChecked={showFilePreview}
                                onChange={(e) =>
                                  filePreviewHandler(e.target.checked)
                                }
                              />
                            </Flex>
                          </Tooltip>
                        </FormControl>
                        <Controls />
                      </ReactFlow>
                    ) : (
                      <Spinner />
                    )}
                  </Flex>
                </Flex>
              </Flex>
            </>
          </Flex>
        ) : (
          <Spinner />
        )}
        <>
          {/* <Modal isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent bg="grey3" color="white">
            <ModalHeader>Add Collaborator</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="700" fontSize="18px" mb="5px">
                Current Collaborators
              </Text>

              <Text fontWeight="700" color="green" fontSize="14px" mb="15px">
                {collabs &&
                  collabs.split(",").map((collab) => {
                    return (
                      collab !== " " && (
                        <Flex
                          flexDir="row"
                          py="3px"
                          justifyContent="space-between"
                          height="fit-content"
                        >
                          <Text>{collab}</Text>
                          <Text
                            color="gray"
                            border="0.5px solid gray"
                            py="0.5px"
                            px="6px"
                            cursor="pointer"
                            onClick={() => collabRemoveHandler(collab)}
                          >
                            X
                          </Text>
                        </Flex>
                      )
                    );
                  })}
              </Text>
              <Select placeholder="Select email" ref={emailA}>
                {dropdownCollaborators
                  ? dropdownCollaborators.map((d, id) => (
                    <option value={d}>{d}</option>
                  ))
                  : null}
              </Select>
            </ModalBody>

            <ModalFooter>
              <Button bg="yellow" mr={3} onClick={collabHandler} color="white">
                Add Collaborator
              </Button>
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal> */}
        </>
        <>
          <Modal isOpen={isOpen5} onClose={onClose5} isCentered>
            <ModalOverlay />
            <ModalContent bg="grey3" color="white">
              <ModalHeader>Add Clients</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Text fontWeight="700" fontSize="18px" mb="5px">
                  Current Clients
                </Text>
                <Text fontWeight="700" color="green" fontSize="14px" mb="15px">
                  {clients &&
                    clients?.map((client) => {
                      return (
                        client !== " " && (
                          <Flex
                            flexDir="row"
                            py="3px"
                            justifyContent="space-between"
                            height="fit-content"
                          >
                            <Text>{client}</Text>
                            <Text
                              color="gray"
                              border="0.5px solid gray"
                              py="0.5px"
                              px="6px"
                              cursor="pointer"
                              onClick={() => clientRemoveHandler(client)}
                            >
                              X
                            </Text>
                          </Flex>
                        )
                      );
                    })}
                </Text>
                <Select placeholder="Select email" ref={emailView}>
                  {dropdownClients
                    ? dropdownClients.map((d, id) => (
                        <option value={d}>{d}</option>
                      ))
                    : null}
                </Select>
              </ModalBody>

              <ModalFooter>
                <Button
                  bg="yellow"
                  mr={3}
                  onClick={clientHandler}
                  color="white"
                >
                  Add Client
                </Button>
                <Button variant="ghost" onClick={onClose5}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
        <>
          <Modal isOpen={isOpen4} onClose={onClose4} isCentered>
            <ModalOverlay />
            <ModalContent bg="grey3" color="white">
              <ModalHeader>Add Viewers</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Text fontWeight="700" fontSize="18px" mb="5px">
                  Current Viewers
                </Text>
                <Text fontWeight="700" color="green" fontSize="14px" mb="15px">
                  {viewers &&
                    viewers.split(",").map((viewer) => {
                      return (
                        viewer !== " " && (
                          <Flex
                            flexDir="row"
                            py="3px"
                            justifyContent="space-between"
                            height="fit-content"
                          >
                            <Text>{viewer}</Text>
                            <Text
                              color="gray"
                              border="0.5px solid gray"
                              py="0.5px"
                              px="6px"
                              cursor="pointer"
                              onClick={() => viewerRemoveHandler(viewer)}
                            >
                              X
                            </Text>
                          </Flex>
                        )
                      );
                    })}
                </Text>
                <Select placeholder="Select email" ref={emailView}>
                  {dropdownViewers
                    ? dropdownViewers.map((d, id) => (
                        <option value={d}>{d}</option>
                      ))
                    : null}
                </Select>
              </ModalBody>

              <ModalFooter>
                <Button
                  bg="yellow"
                  mr={3}
                  onClick={viewerHandler}
                  color="white"
                >
                  Add Viewer
                </Button>
                <Button variant="ghost" onClick={onClose4}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
        <>
          <Modal bg="#444d54" isOpen={isOpen2} onClose={onClose2} isCentered>
            <ModalOverlay BG="#2A3843" />
            {projectInfo ? (
              <ModalContent bg="#444d54">
                <ModalHeader color="white">Edit Project</ModalHeader>
                <ModalBody>
                  <Flex flexDir="column" mb="10px">
                    <Text
                      color="white"
                      fontWeight="700"
                      fontSize="18px"
                      mb="5px"
                      mt="15px"
                    >
                      Project Title
                    </Text>
                    <Input
                      bg="#525C64"
                      color="white"
                      fontWeight="700"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    ></Input>
                  </Flex>
                  <Flex flexDir="column">
                    <Text
                      color="white"
                      fontWeight="700"
                      fontSize="18px"
                      mb="5px"
                    >
                      Industry
                    </Text>
                    <Select
                      bg="#525C64"
                      color="white"
                      value={industry}
                      fontWeight="700"
                      onChange={(e) => setIndustry(e.target.value)}
                    >
                      <option value="Financial Services">
                        Financial Services
                      </option>
                      <option value="Healthcare">Healthcare</option>
                      <option value="Retail">Retail</option>
                      <option value="Technology">Technology</option>
                      <option value="Government">Government</option>
                      <option value="Legal">Legal</option>
                      <option value="Other">Other</option>
                    </Select>
                  </Flex>
                  <Flex flexDir="column">
                    <Text
                      color="white"
                      fontWeight="700"
                      fontSize="18px"
                      mb="5px"
                      mt="15px"
                    >
                      Name of the Client
                    </Text>
                    <Input
                      bg="#525C64"
                      color="white"
                      fontWeight="700"
                      value={client}
                      onChange={(e) => setClient(e.target.value)}
                    ></Input>
                  </Flex>
                  <Flex flexDir="column">
                    <Text
                      color="white"
                      fontWeight="700"
                      fontSize="18px"
                      mb="5px"
                      mt="15px"
                    >
                      Project Code
                    </Text>
                    <Input
                      bg="#525C64"
                      color="white"
                      fontWeight="700"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                    ></Input>
                  </Flex>
                  <Flex flexDir="column">
                    <Text
                      color="white"
                      fontWeight="700"
                      fontSize="18px"
                      mb="5px"
                    >
                      Visibility
                    </Text>
                    <Select
                      bg="#525C64"
                      color="white"
                      value={visibility}
                      onChange={(e) => setVisibility(e.target.value)}
                      fontWeight="700"
                    >
                      <option value="public">Public</option>
                      <option value="private">Private</option>
                    </Select>
                  </Flex>
                </ModalBody>

                <ModalFooter mt="10px">
                  <Button
                    bg="yellow"
                    color="white"
                    mr={3}
                    onClick={editProjectHandler}
                  >
                    Edit Project
                  </Button>
                  <Button color="white" variant="ghost" onClick={onClose2}>
                    Cancel
                  </Button>
                </ModalFooter>
              </ModalContent>
            ) : null}
          </Modal>
        </>
        <>
          <Modal bg="#444d54" isOpen={isOpen3} onClose={onClose3} isCentered>
            <ModalOverlay BG="#0000004D" />
            <ModalContent bg="#444d54">
              <ModalHeader color="white">Create a template</ModalHeader>
              <ModalBody>
                <Flex flexDir="column">
                  
                  {/* <Text color="white"
                    fontSize="16px"
                    >
                    Description
                  </Text> */}
                  <Textarea
                    value={stateDescription}
                    bg="#525C64"
                    color="#fefefe"
                    fontWeight="200"
                    variant="outline"
                    minH="150px"
                    _focus={{
                      border: "0.5px solid white",
                      boxShadow: "none", // removes the default Chakra UI focus shadow
                      outline: "none", // removes the browser's default focus outline
                    }}
                    border="none"
                    onChange={handleDescriptionChange}
                    placeholder="Enter description.."
                    mb="15px"
                  />
                  <Checkbox
                    ref={keepFiles}
                    color="white"
                    fontSize="12px"
                    m="5px"
                    fontWeight="300"

                  >
                    Include files and key findings
                  </Checkbox>
                  <Checkbox
                    ref={withCollabs}
                    color="white"
                    fontSize="12px"
                    m="5px"
                    fontWeight="300"

                  >
                    Keep access permissions
                  </Checkbox>
                </Flex>
              </ModalBody>

              <ModalFooter mt="10px">
                <Button
                  bg="yellow1"
                  color="white"
                  fontSize="14px"
                  mr="10px"
                  onClick={createTemplate}
                >
                  Make template
                </Button>
                <Button color="white" variant="ghost" onClick={onClose3}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
        <>
          <Modal bg="#444d54" isOpen={isOpen9} onClose={onClose9} isCentered>
            <ModalOverlay BG="#0000004D" />
            <ModalContent bg="#444d54">
              <ModalHeader color="white">Clone this project</ModalHeader>
              <ModalBody>
                <Flex flexDir="column">
                  
                  {/* <Text color="white"
                    fontSize="16px"
                    >
                    Description
                  </Text> */}
                  {/* <Textarea
                    value={stateDescription}
                    bg="#525C64"
                    color="#fefefe"
                    fontWeight="200"
                    variant="outline"
                    minH="150px"
                    _focus={{
                      border: "0.5px solid white",
                      boxShadow: "none", // removes the default Chakra UI focus shadow
                      outline: "none", // removes the browser's default focus outline
                    }}
                    border="none"
                    onChange={handleDescriptionChange}
                    placeholder="Enter description.."
                    mb="15px"
                  /> */}
                  <Checkbox
                    ref={keepFiles2}
                    color="white"
                    fontSize="12px"
                    m="5px"
                    fontWeight="300"

                  >
                    Include files and key findings
                  </Checkbox>
                  <Checkbox
                    ref={withCollabs2}
                    color="white"
                    fontSize="12px"
                    m="5px"
                    fontWeight="300"

                  >
                    Keep access permissions
                  </Checkbox>
                </Flex>
              </ModalBody>

              <ModalFooter mt="10px">
                <Button
                  bg="yellow1"
                  color="white"
                  fontSize="14px"
                  mr="10px"
                  onClick={copyProjectHandler}
                >
                  Copy now
                </Button>
                <Button color="white" variant="ghost" onClick={onClose9}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
        <>
          <Modal bg="#444d54" isOpen={isOpen6} onClose={onClose6} isCentered>
            <ModalOverlay BG="#0000004D" />
            <ModalContent bg="#444d54" color="white">
              <ModalHeader>Add project to folder</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                {/* <Text fontWeight="700" fontSize="18px" mb="5px">
              Current Viewers
            </Text> */}
                <Text fontWeight="700" color="green" fontSize="14px" mb="15px">
                  {/* {viewers &&
                viewers.split(",").map((viewer) => {
                  return (
                    viewer !== " " && (
                      <Flex
                        flexDir="row"
                        py="3px"
                        justifyContent="space-between"
                        height="fit-content"
                      >
                        <Text>{viewer}</Text>
                        <Text
                          color="gray"
                          border="0.5px solid gray"
                          py="0.5px"
                          px="6px"
                          cursor="pointer"
                          onClick={() => viewerRemoveHandler(viewer)}
                        >
                          X
                        </Text>
                      </Flex>
                    )
                  );
                })} */}
                </Text>
                <Select placeholder="Select folder" ref={folderId}>
                  {folders
                    ? folders.map((d, id) => (
                        <option value={d.id}>{d.title}</option>
                      ))
                    : null}
                </Select>
              </ModalBody>

              <ModalFooter>
                <Button
                  bg="background.yellow1"
                  mr={3}
                  onClick={addProjectToFolderHandler}
                  color="white"
                >
                  Add to folder
                </Button>
                <Button variant="ghost" onClick={onClose6}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
          <>
            <Modal
             bg="#444d54"
              isOpen={isOpenAccess}
              onClose={() => {
                setSelectedRole("Select Role");
                onCloseAccess();
              }}
              isCentered
              size="xl"
            >
              <ModalOverlay BG="#0000004D" />
              <ModalContent bg="#444d54" color="white">
                <ModalHeader fontSize={"2xl"}>
                  Share "{projectInfo?.title}"
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Flex flexDir="row" mb={3}>
                    <Flex width="69%" flexDir="column">
                      <ReactSearchAutocomplete
                        items={accessList}
                        fuseOptions={{
                          threshold: 0.2,
                          useExtendedSearch: true,
                          findAllMatches: true,
                          distance: 150,
                          ignoreLocation: true,
                        }}
                        showIcon={true}
                        icon={<SearchIcon color="white" />}
                        onSearch={handleOnSearch}
                        onHover={handleOnHover}
                        onSelect={(mail) => {
                          emailA.current = mail.name;
                        }}
                        onFocus={handleOnFocus}
                        autoFocus
                        styling={{
                          display: "block",
                          borderRadius: "5px",
                          backgroundColor: "#646B72",
                          boxShadow: "none",
                          border: "none",
                          placeholderColor: "white",
                          color: "white",
                          iconColor: "white",
                          lineColor: "white",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 2,
                          showIcon: false,
                          resultItemHoverStyle: {
                            backgroundColor: "grey", // set the background color on hover to grey
                            color: "white",
                          },
                        }}
                        // formatResult={formatResult}
                        maxResults={5}
                        placeholder="Search for users by email"
                      />
                    </Flex>
                    <Menu>
                      <MenuButton
                        as={Button}
                        rightIcon={<ChevronDownIcon />}
                        bg="yellow1"
                        color="white"
                        height="44px"
                        ml={3}
                      >
                        {selectedRole}
                      </MenuButton>
                      <MenuList color="grey3">
                        <MenuItem color="black" onClick={() => setSelectedRole("Client")}>
                          Client
                        </MenuItem>
                        {projectInfo?.visibility === "private" && (
                          <MenuItem color="black" onClick={() => setSelectedRole("Viewer")}>
                            Viewer
                          </MenuItem>
                        )}
                        <MenuItem color="black"
                          onClick={() => setSelectedRole("Collaborator")}
                        >
                          Collaborator
                        </MenuItem>
                        <MenuItem color="black" onClick={() => setSelectedRole("Owner")}>
                          Owner
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Flex>
                  {/* <Text fontWeight="700" fontSize="18px" mb="5px">
                  Current Collaborators
                </Text> */}
                  <Text
                    color="#FFFFFFBF"
                    fontWeight="600"
                    fontSize="16px"
                    mt={3}
                  >
                    People with access
                  </Text>
                  <Text fontWeight="700" fontSize="14px" mb="15px">
                    <Box maxH="150px" overflowY="auto">
                      {hasAccessList &&
                        hasAccessList.map((user, id) => (
                          <Flex
                            // flexDir="column"
                            flexDir="row"
                            py="3px"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Flex
                              justifyContent="space-between"
                              alignItems="center"
                              height="fit-content"
                            >
                              <Avatar
                                size="sm"
                                bg="white"
                                key={id}
                                name={user?.name}
                                src={user?.name}
                                color="#2D3842"
                                fontWeight="700"
                                mr={2}
                                border="1px solid #2D3842"
                              />
                              <Text>
                                <Text>{user?.name}</Text>
                                <Text fontWeight="400" color="grey1">
                                  {user?.email} ({user?.role})
                                </Text>
                              </Text>
                            </Flex>
                            {user.role !== "owner" && (
                              <Text
                                mr="6px"
                                color="grey1"
                                fontSize={"md"}
                                cursor="pointer"
                                onClick={() => {
                                  user.role === "client" &&
                                    clientRemoveHandler(user.email);
                                  user.role === "viewer" &&
                                    viewerRemoveHandler(user.email);
                                  user.role === "collaborator" &&
                                    collabRemoveHandler(user.email);
                                }}
                              >
                                <BiTrash />
                              </Text>
                            )}
                          </Flex>
                        ))}
                    </Box>

                    <Text fontWeight="600" fontSize="16px" mt={3} color="grey1">
                      General Visibility
                    </Text>
                    <Flex flexDir="row" alignItems="center">
                      <Text fontWeight="400" fontSize="18px">
                        Public
                      </Text>
                      <Switch
                        px={1}
                        isChecked={
                          projectInfo?.visibility === "private" ? true : false
                        }
                        onChange={(e) => {
                          projectVisibility.current = e.target.checked
                            ? "private"
                            : "public";
                          editProjectHandler();
                        }}
                        size="sm"
                        id="email-alerts"
                      />
                      <Text fontWeight="400" fontSize="18px">
                        Private
                      </Text>
                    </Flex>
                  </Text>
                </ModalBody>

                <ModalFooter>
                  <Button
                    bg="yellow1"
                    mr={3}
                    onClick={accessHandler}
                    color="white"
                  >
                    Add User
                  </Button>
                  <Button variant="ghost" onClick={onCloseAccess}>
                    Cancel
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </>
        </>
      </Flex>
      <>
        <Box
          borderLeft={isOpen7 && "2px solid #495661"}
          pl={1}
          bg="bg"
          w={isOpen7 ? "270px" : "0"}
          overflow="auto"
          transition="width 0.3s ease"
          position="fixed"
          right="0"
        >
          <Flex flexDir="column" p={1}>
            <Flex alignItems="center" justifyContent={"space-between"}>
              <Text fontSize="17px" color="white" fontWeight="bold">
                Version History
              </Text>
              {/* close button */}
              <Button
                bg="inherit"
                _hover={{ bg: "inherit" }}
                color="white"
                fontSize="14px"
                // mr="10px"
                onClick={onToggle7}
              >
                <svg fill="none" viewBox="0 0 15 15" height="1em" width="1em">
                  <path
                    fill="currentColor"
                    fillRule="evenodd"
                    d="M12.854 2.854a.5.5 0 00-.708-.708L7.5 6.793 2.854 2.146a.5.5 0 10-.708.708L6.793 7.5l-4.647 4.646a.5.5 0 00.708.708L7.5 8.207l4.646 4.647a.5.5 0 00.708-.708L8.207 7.5l4.647-4.646z"
                    clipRule="evenodd"
                  />
                </svg>
              </Button>
            </Flex>
            <Flex height="100vh" overflow={"auto"} flexDir={"column"}>
              <Flex height="70.5vh" flexDir="column" color="white">
                {versions &&
                  versions.map((version, index) => (
                    <Flex
                      id={index}
                      cursor={"pointer"}
                      m={1}
                      p={3}
                      fontSize={"14px"}
                      borderRadius={5}
                      onClick={() => versionClickHandler(version.id)}
                      bg={version.id === activeVersion ? "green" : "grey3"}
                    >
                      {version.version_date
                        ?.split("T")[1]
                        .split(".")[0]
                        .slice(0, 5)}
                      , &nbsp;
                      {version.version_date?.split("T")[0]}
                    </Flex>
                  ))}
              </Flex>
              <Button
                bg="yellow1"
                p={1}
                px={2}
                color="white"
                fontSize="15px"
                // mr="10px"
                as="a"
                w="100%"
                onClick={() => restoreVersion(activeVersion)}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                    fill="white"
                  />
                  <path
                    d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                    fill="white"
                  />
                </svg>
                &nbsp; Restore back to this version
              </Button>
              <Button
                bg="#444d54"
                p={1}
                px={2}
                color="white"
                my={2}
                fontSize="13px"
                width="100%"
                // mr="10px"
                as="a"
                onClick={createProjectHandler}
              >
                <svg
                  width="16"
                  height="19"
                  viewBox="0 0 16 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4578 4.78426C14.8043 4.43776 14.9949 3.97759 14.9949 3.48809C14.9949 2.99859 14.8043 2.53843 14.4578 2.19193L13.0039 0.738094C12.6574 0.391594 12.1973 0.200928 11.7078 0.200928C11.2183 0.200928 10.7581 0.391594 10.4125 0.737178L0.666504 10.4529V14.5H4.71175L14.4578 4.78426ZM11.7078 2.03426L13.1625 3.48718L11.705 4.93918L10.2512 3.48626L11.7078 2.03426ZM2.49984 12.6667V11.2138L8.95317 4.78059L10.407 6.23443L3.95459 12.6667H2.49984ZM0.666504 16.3333H15.3332V18.1667H0.666504V16.3333Z"
                    fill="white"
                  />
                </svg>
                &nbsp; New project from this version
              </Button>{" "}
              <Button
                bg="#444d54"
                p={1}
                px={2}
                color="white"
                my={1}
                fontSize="14px"
                width="100%"
                // mr="10px"
                as="a"
                onClick={() => putVersion()}
              >
                &nbsp; Backup Now
              </Button>
            </Flex>
          </Flex>
        </Box>
        <Box
          borderLeft={isOpenDrawer && "2px solid #495661"}
          pl={1}
          bg="bg"
          w={isOpenDrawer ? "270px" : "0"}
          overflow="auto"
          transition="width 0.3s ease"
          position="fixed"
          right="0"
        >
          <Flex flexDir="column" p={1}>
            <Flex alignItems="center" justifyContent={"space-between"}>
              <Text fontSize="17px" color="white" fontWeight="bold">
                See All Files
              </Text>
              {/* close button */}
              <Button
                bg="inherit"
                _hover={{ bg: "inherit" }}
                color="white"
                fontSize="14px"
                // mr="10px"
                onClick={onToggleDrawer}
              >
                <svg fill="none" viewBox="0 0 15 15" height="1em" width="1em">
                  <path
                    fill="currentColor"
                    fillRule="evenodd"
                    d="M12.854 2.854a.5.5 0 00-.708-.708L7.5 6.793 2.854 2.146a.5.5 0 10-.708.708L6.793 7.5l-4.647 4.646a.5.5 0 00.708.708L7.5 8.207l4.646 4.647a.5.5 0 00.708-.708L8.207 7.5l4.647-4.646z"
                    clipRule="evenodd"
                  />
                </svg>
              </Button>
            </Flex>
            <Flex height="100vh" overflow={"auto"} flexDir={"column"}>
              <Flex
                height={"calc(100% - 100px)"}
                flexDir="column"
                color="white"
                style={{
                  overflowY: "scroll",
                }}
              >
                {uniqueFileData.map((version, index) => (
                  <Flex
                    cursor={"pointer"}
                    onClick={() =>
                      window.open(version.file, "_blank", "noopener,noreferrer")
                    }
                    cur
                    target="_blank"
                    color="white"
                    p={2}
                    m={2}
                    background="grey3"
                    border={`2px solid ${
                      version?.version === "new"
                        ? "green"
                        : version?.version === "old"
                        ? "red"
                        : "none"
                    }`}
                    borderRadius="3px"
                  >
                    <Flex flexDir="column" height="100%" maxW={"100%"}>
                      <Flex flexDir={"column"} m={1} maxW={"100%"}>
                        <Text
                          color="white"
                          fontSize="13px"
                          lineHeight="1.2"
                          fontWeight="700"
                          maxW="100%"
                        >
                          {version?.title}
                        </Text>
                        <Tooltip
                          hasArrow
                          bg="#444d54"
                          color="white"
                          placement="bottom"
                          label={version?.title}
                        >
                          <Flex maxHeight="170px" py={3}>
                            {version?.thumbnail ? (
                              <img
                                src={version.thumbnail}
                                alt={"thumbnail"}
                                style={{
                                  objectFit: "contain",
                                  minWidth: "80px",
                                }}
                              />
                            ) : (
                              <>
                                {(version.file.includes("sheet") ||
                                  version.file.includes("csv") ||
                                  version.file.includes("xls")) &&
                                  !version.file.includes(".zip") && (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 48 48"
                                      width="48"
                                      height="48"
                                    >
                                      <linearGradient
                                        id="PTsiEfj2THKtO9xz06mlla"
                                        x1="24"
                                        x2="24"
                                        y1="5"
                                        y2="43"
                                        gradientUnits="userSpaceOnUse"
                                      >
                                        <stop offset="0" stopColor="#21ad64" />
                                        <stop offset="1" stopColor="#088242" />
                                      </linearGradient>
                                      <path
                                        fill="url(#PTsiEfj2THKtO9xz06mlla)"
                                        d="M39,16v25c0,1.105-0.895,2-2,2H11c-1.105,0-2-0.895-2-2V7c0-1.105,0.895-2,2-2h17L39,16z"
                                      />
                                      <path
                                        fill="#61e3a7"
                                        d="M28,5v9c0,1.105,0.895,2,2,2h9L28,5z"
                                      />
                                      <path
                                        fill="#107c42"
                                        d="M39,16h-9c-0.473,0-0.917-0.168-1.257-0.444L39,27V16z"
                                      />
                                      <path
                                        fill="#fff"
                                        d="M32,23H16c-0.553,0-1,0.448-1,1v12c0,0.552,0.447,1,1,1h16c0.553,0,1-0.448,1-1V24 C33,23.448,32.553,23,32,23z M17,29h4v2h-4V29z M23,29h8v2h-8V29z M31,27h-8v-2h8V27z M21,25v2h-4v-2H21z M17,33h4v2h-4V33z M23,35 v-2h8v2H23z"
                                      />
                                      <path
                                        d="M32,22.5c0.827,0,1.5,0.673,1.5,1.5v12c0,0.827-0.673,1.5-1.5,1.5H16c-0.827,0-1.5-0.673-1.5-1.5V24 c0-0.827,0.673-1.5,1.5-1.5H32 M32,22H16c-1.103,0-2,0.897-2,2v12c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V24 C34,22.897,33.103,22,32,22L32,22z"
                                        opacity=".05"
                                      />
                                      <path
                                        d="M32,23c0.553,0,1,0.448,1,1v12c0,0.552-0.447,1-1,1H16c-0.553,0-1-0.448-1-1V24c0-0.552,0.447-1,1-1 H32 M32,22.5H16c-0.827,0-1.5,0.673-1.5,1.5v12c0,0.827,0.673,1.5,1.5,1.5h16c0.827,0,1.5-0.673,1.5-1.5V24 C33.5,23.173,32.827,22.5,32,22.5L32,22.5z"
                                        opacity=".07"
                                      />
                                    </svg>
                                  )}
                                {version.file.includes("document") && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 48 48"
                                    width="48"
                                    height="48"
                                  >
                                    <path
                                      fill="#2196f3"
                                      d="M37,45H11c-1.657,0-3-1.343-3-3V6c0-1.657,1.343-3,3-3h19l10,10v29C40,43.657,38.657,45,37,45z"
                                    />
                                    <path
                                      fill="#bbdefb"
                                      d="M40 13L30 13 30 3z"
                                    />
                                    <path
                                      fill="#1565c0"
                                      d="M30 13L40 23 40 13z"
                                    />
                                    <path
                                      fill="#e3f2fd"
                                      d="M15 23H33V25H15zM15 27H33V29H15zM15 31H33V33H15zM15 35H25V37H15z"
                                    />
                                  </svg>
                                )}
                                {version.file
                                  .toLowerCase()
                                  .includes("sheet") === false &&
                                  version.file
                                    .toLowerCase()
                                    .includes("document") === false &&
                                  version.file
                                    .toLowerCase()
                                    .includes("drive") === false &&
                                  version.file.includes("colab") === false &&
                                  version.file.toLowerCase().includes(".r") ===
                                    false &&
                                  version.file
                                    .toLowerCase()
                                    .includes("ipynb") === false &&
                                  !version.file.toLowerCase().includes(".py") &&
                                  !version.file.toLowerCase().includes("kms") &&
                                  !version.file.includes(".zip") &&
                                  version.file.includes("http") && (
                                    <Text>
                                      <svg
                                        viewBox="0 0 21 21"
                                        fill="currentColor"
                                        height="48"
                                        width="48"
                                      >
                                        <g
                                          fill="none"
                                          fillRule="evenodd"
                                          stroke="currentColor"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        >
                                          <path d="M9.5 11.5c.97 1.367 3.011 1.127 4.011 0l1.989-2c1.124-1.228 1.164-2.814 0-4-1.136-1.157-2.864-1.157-4 0l-2 2" />
                                          <path d="M11.5 10.57c-.97-1.367-3-1.197-4-.07l-2 1.975c-1.124 1.228-1.164 2.839 0 4.025 1.136 1.157 2.864 1.157 4 0l2-2" />
                                        </g>
                                      </svg>
                                    </Text>
                                  )}
                                {version.file
                                  .toLowerCase()
                                  .includes("sheet") === false &&
                                  version.file
                                    .toLowerCase()
                                    .includes("document") === false &&
                                  version.file
                                    .toLowerCase()
                                    .includes("drive") === false &&
                                  version.file.includes("colab") === false &&
                                  version.file.toLowerCase().includes(".r") ===
                                    false &&
                                  version.file
                                    .toLowerCase()
                                    .includes("ipynb") === false &&
                                  !version.file.toLowerCase().includes(".py") &&
                                  !version.file.toLowerCase().includes("kms") &&
                                  !version.file.includes("http") &&
                                  !version.file.includes(".zip") && (
                                    <Text>
                                      <svg
                                        viewBox="0 0 1024 1024"
                                        fill="currentColor"
                                        height="48"
                                        width="48"
                                      >
                                        <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h184a8 8 0 008-8v-48a8 8 0 00-8-8H320z" />
                                      </svg>
                                    </Text>
                                  )}
                                {(version.file.includes("colab") ||
                                  version.file.includes(".py") ||
                                  version.file.includes("ipynb") ||
                                  version.file.toLowerCase().includes(".r")) &&
                                  !version.file.includes(".zip") && (
                                    <Text>
                                      <svg
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                        height="48"
                                        width="48"
                                      >
                                        <path d="M9.293 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4.707A1 1 0 0013.707 4L10 .293A1 1 0 009.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 01-1-1zM6.646 7.646a.5.5 0 11.708.708L5.707 10l1.647 1.646a.5.5 0 01-.708.708l-2-2a.5.5 0 010-.708l2-2zm2.708 0l2 2a.5.5 0 010 .708l-2 2a.5.5 0 01-.708-.708L10.293 10 8.646 8.354a.5.5 0 11.708-.708z" />
                                      </svg>
                                    </Text>
                                  )}
                                {version.file.includes(".zip") && (
                                  <Text>
                                    <svg
                                      viewBox="0 0 1024 1024"
                                      fill="currentColor"
                                      height="48"
                                      width="48"
                                    >
                                      <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z" />
                                    </svg>
                                  </Text>
                                )}
                                {version.file
                                  .toLowerCase()
                                  .includes("sheet") === false &&
                                  !version.file.includes("csv") &&
                                  !version.file.includes("xls") &&
                                  version.file
                                    .toLowerCase()
                                    .includes("document") === false &&
                                  version.file
                                    .toLowerCase()
                                    .includes("drive") === false &&
                                  version.file.includes("colab") === false &&
                                  version.file.toLowerCase().includes(".r") ===
                                    false &&
                                  version.file
                                    .toLowerCase()
                                    .includes("ipynb") === false &&
                                  version.file.toLowerCase().includes("kms") &&
                                  !version.file.includes(".zip") && (
                                    <Text>
                                      <svg
                                        width="48"
                                        height="48"
                                        viewBox="0 0 39 39"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <rect
                                          width="39"
                                          height="39"
                                          rx="19.5"
                                          fill="#2D3842"
                                        />
                                        <path
                                          d="M19.5683 8.37869L23.941 17.8038L8.5946 30.7297L19.5683 8.37869Z"
                                          fill="#BC9842"
                                        />
                                        <path
                                          d="M19.4711 8.35135L15.0984 17.7765L30.4448 30.7024L19.4711 8.35135Z"
                                          fill="#BC9842"
                                        />
                                      </svg>
                                    </Text>
                                  )}{" "}
                                {version.file.includes("sheet") === false &&
                                  version.file.includes("document") === false &&
                                  version.file.includes("drive") && (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 48 48"
                                      width="48"
                                      height="48"
                                    >
                                      <path
                                        fill="#FFC107"
                                        d="M17 6L31 6 45 30 31 30z"
                                      />
                                      <path
                                        fill="#1976D2"
                                        d="M9.875 42L16.938 30 45 30 38 42z"
                                      />
                                      <path
                                        fill="#4CAF50"
                                        d="M3 30.125L9.875 42 24 18 17 6z"
                                      />
                                    </svg>
                                  )}
                              </>
                            )}
                          </Flex>
                        </Tooltip>
                        <Text color="#ACACAC" fontSize="12px">
                          {version.description}
                        </Text>
                      </Flex>
                    </Flex>
                  </Flex>
                ))}
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </>

      <Modal bg="#444d54" isOpen={isOpen8} onClose={onClose8} isCentered size="xl">
        <ModalOverlay BG="#0000004D" />

        <ModalContent bg="#444d54"  color="white">
        <ModalCloseButton />

          <ModalHeader color="white">AI Summary</ModalHeader>
          <ModalBody>
            <Flex flexDir="column" mb="10px">
            <Text color="white">
                This is the summary of the project generated by the AI model.
              </Text>
              <Text
                color="black"
                fontWeight="400"
                border="2px solid grey"
                py="13px"
                px="8px"
                borderRadius="5px"
                fontSize="15px"
                bg="white"
                my={1}
                h="300px"
                overflowY="auto"
              >
                {summary!==null ? summary : <Spinner/>}
              </Text>
             
            </Flex>
          </ModalBody>

          {/* <ModalFooter mt="10px">
            <Button
              bg="yellow1"
              color="white"
              fontSize="14px"
              mr="10px"
              onClick={generateSummaryHandler}
            >
              Generate Again
            </Button>
            <Button color="white" variant="ghost" onClick={onClose8}>
              Cancel
            </Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </>
  );
};

export default Project;